import React from 'react';

export const Archive = () => (
  <svg width="14" height="14" viewBox="1.33 1.33 13.34 13.34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M1.3335 3.33333C1.3335 2.70479 1.3335 2.39053 1.52876 2.19526C1.72402 2 2.03829 2 2.66683 2H13.3335C13.962 2 14.2763 2 14.4716 2.19526C14.6668 2.39053 14.6668 2.70479 14.6668 3.33333C14.6668 3.96187 14.6668 4.27614 14.4716 4.47141C14.2763 4.66667 13.962 4.66667 13.3335 4.66667H2.66683C2.03829 4.66667 1.72402 4.66667 1.52876 4.47141C1.3335 4.27614 1.3335 3.96187 1.3335 3.33333Z"
    />
    <path
      fill="currentColor"
      d="M13.3794 5.66629C13.4736 5.66633 13.5702 5.66637 13.6668 5.66504V8.66627C13.6668 11.1804 13.6668 12.4375 12.8858 13.2185C12.1048 13.9996 10.8476 13.9996 8.3335 13.9996H7.66683C5.15267 13.9996 3.8956 13.9996 3.11454 13.2185C2.3335 12.4375 2.3335 11.1804 2.3335 8.66627V5.66504C2.43008 5.66637 2.52682 5.66633 2.62092 5.66629L7.50016 5.66629V10.0299L6.37182 8.77621C6.18708 8.57094 5.87094 8.55434 5.66568 8.73907C5.46043 8.92381 5.44379 9.23994 5.62852 9.44521L7.6285 11.6674C7.72336 11.7727 7.85843 11.8329 8.00016 11.8329C8.1419 11.8329 8.27696 11.7727 8.37183 11.6674L10.3718 9.44521C10.5566 9.23994 10.5399 8.92381 10.3346 8.73907C10.1294 8.55434 9.81323 8.57094 9.6285 8.77621L8.50016 10.0299V5.66629L13.3794 5.66629Z"
    />
  </svg>
);

export default Archive;
